module.exports = __webpack_public_path__ + "04_medium_beige.9dce63d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_medium_beige.png
// module id = PuNX
// module chunks = 0